<mat-toolbar>
  Gestor de archivos
  <span class="spacer"></span>
  <button mat-icon-button matTooltip="Recargar datos" (click)="ngOnInit()"><mat-icon color="primary">refresh</mat-icon></button>
  <button mat-button [matMenuTriggerFor]="beforeMenu"><mat-icon color="primary">menu</mat-icon></button>
  <mat-menu #beforeMenu="matMenu" xPosition="before">
    <button mat-menu-item (click)="newFolder()"><mat-icon color="primary">create_new_folder</mat-icon> Nueva carpeta</button>
    <button mat-menu-item (click)="uploadFiles()"><mat-icon color="primary">cloud_upload</mat-icon> Subir fichero</button>
    <button mat-menu-item (click)="paste()" [disabled]="pasteDisabled"><mat-icon color="primary">content_paste</mat-icon> Pegar</button>
  </mat-menu>
</mat-toolbar>

@if (showProgressBar) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<div class="pageContent">
  <div class='infoBLock'>
    <div>
      @if (pathBeautiful.length > 1) {
        <button mat-icon-button matTooltip="Volver" class='pointer' (click)="goBack()"><mat-icon color='primary'>arrow_back</mat-icon></button>
      }
      {{pathBeautiful === '' ? '/' : pathBeautiful}}
    </div>
    <mat-form-field>
      <mat-label>Buscar</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Buscar..." #input>
    </mat-form-field>
  </div>

  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef >

      </th>
      <td mat-cell *matCellDef="let element" class='miniCell'>
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon matTooltip="Acciones" color="primary">more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="rename(element.name)">
            <mat-icon color="primary">create</mat-icon>
            <span>Renombrar</span>
          </button>
          @if (element.type === 'file') {
            <button mat-menu-item (click)="downloadFile(element.name)">
              <mat-icon color="primary">cloud_download</mat-icon>
              <span>Descargar</span>
            </button>
          }
          @if (element.type === 'file') {
            <button mat-menu-item (click)="copy(element.name, 'copy')">
              <mat-icon color="primary">content_copy</mat-icon>
              <span>Copiar</span>
            </button>
          }
          <button mat-menu-item (click)="copy(element.name, 'move')">
            <mat-icon color="primary">content_cut</mat-icon>
            <span>Cortar</span>
          </button>
          @if (element.type === 'directory') {
            <button mat-menu-item (click)="compressFolder(element.name)">
              <mat-icon color="primary">close_fullscreen</mat-icon>
              <span>Comprimir</span>
            </button>
          }
          @if (element.type === 'directory') {
            <button mat-menu-item (click)="deleteFolder(element.name)">
              <mat-icon color="primary">delete</mat-icon>
              <span>Eliminar</span>
            </button>
          }
          @if (element.type === 'file') {
            <button mat-menu-item (click)="deleteFile(element.name)">
              <mat-icon color="primary">delete</mat-icon>
              <span>Eliminar</span>
            </button>
          }
        </mat-menu>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nombre </th>
      <td mat-cell *matCellDef="let element" >
        @if (element.type === 'directory') {
          <span class='pointer' (dblclick)="openFolder(element.name)"><mat-icon color="primary" class='fileTypeIcon'>{{element.type === 'directory' ? 'folder' : getFileExtension(element.name) }}</mat-icon> {{ element.name }}</span>
        }
        @if (element.type === 'file') {
          <span><mat-icon color="primary" class='fileTypeIcon'>{{element.type === 'directory' ? 'folder' : getFileExtension(element.name) }}</mat-icon> {{ element.name }}</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef> Tipo </th>
      <td mat-cell *matCellDef="let element">
        @if (element.type === 'directory') {
          <span class='pointer' (dblclick)="openFolder(element.name)">{{ element.type === 'directory' ? 'Carpeta' : 'Archivo' }}</span>
        }
        @if (element.type === 'file') {
          <span>{{ element.type === 'directory' ? 'Carpeta' : 'Archivo' }}</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="size">
      <th mat-header-cell *matHeaderCellDef> Tamaño </th>
      <td mat-cell *matCellDef="let element">
        @if (element.type === 'directory') {
          <span class='pointer' (dblclick)="openFolder(element.name)">{{ element.size }} </span>
        }
        @if (element.type === 'file') {
          <span>{{ element.size }} </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="lastModified">
      <th mat-header-cell *matHeaderCellDef> Modificado </th>
      <td mat-cell *matCellDef="let element">
        @if (element.type === 'directory') {
          <span class='pointer' (dblclick)="openFolder(element.name)">{{ element.lastModified }}</span>
        }
        @if (element.type === 'file') {
          <span>{{ element.lastModified }}</span>
        }
      </td>
    </ng-container>

    <tr class="mat-row" *matNoDataRow>
      <td class="emptyCell" colspan="5">Directorio vacío<br> <button mat-stroked-button (click)="newFolder()">Crear carpeta</button> <button mat-stroked-button (click)="uploadFiles()">Subir fichero</button></td>
    </tr>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
</div>
